let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a2xOI")).then(() => parcelRequire('3J5rc'));